import React from "react"
export const RouteShipmentDetailContext = React.createContext(null);

export const useRouteShipmentDetailContext = () => {

    const context = React.useContext(RouteShipmentDetailContext);

    if (!context) throw new Error("Route Shipment Detail Context not provided!");

    return context;
}